import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
export var StatusSharedCssClassName = {
  STATUS_CONTAINER: 'statusView-content-wrap',
  STATUS_LOZENGE: 'status-lozenge-span'
};
export var getStatusSharedStyles = function getStatusSharedStyles() {
  return (
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    fg('platform-component-visual-refresh') ?
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    css(_defineProperty({}, ".".concat(StatusSharedCssClassName.STATUS_LOZENGE, " > span "), {
      border: "1px solid ".concat("var(--ds-border-inverse, #FFF)")
    })) : css({})
  );
};